
import { Box, Button, Grid, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useUsuariosStore } from "../../../stores";






export const InformacionCliente = ({ urlEditar }) => {


    const navigate = useNavigate();
    const { usuarioVenta } = useUsuariosStore();
    


    const handleEditarInfo = () => {
        navigate(`${ urlEditar }`);
    }
    


    return (

        <Grid container sx={{background:'#1E1E1E', borderRadius:'10px', p:2, mb:2}}>
            <Box sx={{ width:'100%', display:'flex', justifyContent:'space-between', alignItems:'center', mb:2 }}>
                <Typography variant="h4" sx={{ fontSize:15 }}>CHECKOUT</Typography>
                <Button variant="contained" size="small" onClick={handleEditarInfo} sx={{ color:'#fff', textTransform:'none', 
                    fontWeight:600, px:2, borderRadius:'12px', boxShadow:'0 3px 10px rgba(0,0,0,0.3)'
                }}>
                    Editar
                </Button>
            </Box>

            <Grid container spacing={0.5}>
                <Grid item xs={12} sx={{ display:'flex', justifyContent:'space-between' }}>
                    <Typography sx={{ fontSize:14, fontWeight:'bold' }}>Nombre:</Typography>
                    <Typography sx={{ fontSize:13 }}>{usuarioVenta.nombre}</Typography>
                </Grid>

                <Grid item xs={12} sx={{ display:'flex', justifyContent:'space-between' }}>
                    <Typography sx={{ fontSize:14, fontWeight:'bold' }}>Movil:</Typography>
                    <Typography sx={{ fontSize:13 }}>{usuarioVenta.movil}</Typography>
                </Grid>

                <Grid item xs={12} sx={{ display:'flex', justifyContent:'space-between' }}>
                    <Typography sx={{ fontSize:14, fontWeight:'bold' }}>Dirección:</Typography>
                    <Typography sx={{ fontSize:13 }}>{usuarioVenta.direccion}</Typography>
                </Grid>

                <Grid item xs={12} sx={{ display:'flex', justifyContent:'space-between' }}>
                    <Typography sx={{ fontSize:14, fontWeight:'bold' }}>Ciudad:</Typography>
                    <Typography sx={{ fontSize:13 }}>{usuarioVenta.ciudad}</Typography>
                </Grid>
            </Grid> 


            

        </Grid>
    )


}
